import { render, staticRenderFns } from "./seoMixinHx.vue?vue&type=template&id=5f143c45&"
import script from "./seoMixinHx.vue?vue&type=script&lang=js&"
export * from "./seoMixinHx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports